var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconSelectionAll = function SvgIconSelectionAll(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.5 3.75a1 1 0 0 1 1-1h3a1 1 0 1 1 0 2h-3a1 1 0 0 1-1-1M9.5 20.25a1 1 0 0 1 1-1h3a1 1 0 1 1 0 2h-3a1 1 0 0 1-1-1M17.25 2.75a1 1 0 1 0 0 2h2v2a1 1 0 1 0 2 0V4.5a1.75 1.75 0 0 0-1.75-1.75zM20.25 9.5a1 1 0 0 1 1 1v3a1 1 0 1 1-2 0v-3a1 1 0 0 1 1-1M21.25 17.25a1 1 0 1 0-2 0v2h-2a1 1 0 1 0 0 2h2.25a1.75 1.75 0 0 0 1.75-1.75zM3.75 9.5a1 1 0 0 1 1 1v3a1 1 0 1 1-2 0v-3a1 1 0 0 1 1-1M4.75 17.25a1 1 0 1 0-2 0v2.25a1.75 1.75 0 0 0 1.75 1.75h2.25a1 1 0 1 0 0-2h-2zM3.263 3.263A1.75 1.75 0 0 1 4.5 2.75h2.25a1 1 0 0 1 0 2h-2v2a1 1 0 0 1-2 0V4.5c0-.464.184-.91.513-1.237"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M7.5 6.5a1 1 0 0 0-1 1v9a1 1 0 0 0 1 1h9a1 1 0 0 0 1-1v-9a1 1 0 0 0-1-1zm1 9v-7h7v7z",
    clipRule: "evenodd"
  }))));
};
export default SvgIconSelectionAll;